
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cancellation-refund-policy",
      function () {
        return require("private-next-pages/cancellation-refund-policy.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cancellation-refund-policy"])
      });
    }
  